module.exports = __webpack_public_path__ + "img/V1-bg.6402c81f.png";